"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { logException } from '@autoguru/logs';
import { getLoggingAgent } from '@autoguru/logs/new-relic/agent';
import { createLogger } from '@autoguru/utilities';
import { GraphError } from './GraphError';
const loggerCategory = 'relay';
const logger = createLogger(loggerCategory);
export const relayLogFn = event => {
  if (event.name === 'network.error') {
    typeof window !== 'undefined' && logException(event.error, {}, getLoggingAgent());
    if (event.error instanceof GraphError) {
      const {
        graphqlErrors = []
      } = event.error;
      if (process.env.NODE_ENV !== "production" && process.__browser__) {
        for (const item of graphqlErrors) {
          console.error(`${loggerCategory} ${event.name} (${event.transactionID})`, item);
        }
      } else if (!process.__browser__) {
        logger.error(event.name, {
          transactionID: event.transactionID,
          message: event.error.message,
          stackTrace: event.error.stack,
          graphqlErrors
        });
      }
    } else {
      logger.error(event.name, {
        transactionID: event.transactionID,
        message: event.error.message,
        stackTrace: event.error.stack
      });
    }
  }
};